import React from "react"
import { StyledText } from "../common/styled-text"
import { cn } from "~/common/cn"

type SectionHeadingProps = {
  firstLine: string
  secondLine: string
  highlightSecond?: boolean
  children?: React.ReactNode
}

export function SectionHeading({
  firstLine,
  secondLine,
  highlightSecond = false,
  children,
}: SectionHeadingProps) {
  return (
    <div className="px-4 text-center md:px-0 md:text-left">
      <StyledText className="text-white">{firstLine}</StyledText>

      <StyledText
        variant={highlightSecond ? "stroke" : "default"}
        className={cn("relative z-10", highlightSecond ? "text-support-lilac" : "text-base-black")}
      >
        {" "}
        {secondLine}
      </StyledText>

      {children}
    </div>
  )
}
